import React, {useState} from "react";
import {
    Edit,
    TabbedForm,
    FormTab,
    TextInput,
    SelectInput,
    ReferenceInput,
    ArrayInput,
    DateInput,
    AutocompleteInput,
    FormDataConsumer,
    Toolbar,
    SimpleFormIterator,
    CardActions,
    ShowButton,
    BooleanInput
} from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';

import PhoneArrayInput from "../component/PhoneArrayInput";
import DocumentArrayInput from "../component/DocumentArrayInput";
import EmployeeQualificationsArray from "../component/EmployeeQualificationsArray";

import specialities from "../helper/Speciality";
import required from "../helper/Required";
import SaveButtonAware from "../component/SaveButtonAware";
import {Typography, Box, Paper, Dialog, DialogContent, DialogContentText, DialogActions} from '@material-ui/core';
import CustomAddButton from "../component/CustomAddButton";
import CustomRemoveButton from "../component/CustomRemoveButton";
import errorMessage from "../helper/ErrorMessage";
import "./styles/main.css"
import {useForm} from "react-final-form";
import ButtonMui from "@material-ui/core/Button";
import LoadingComponent from "../component/LoadingComponent";
import SignComponent from "../component/SignComponent";
import SignedRequest from "../component/SignedRequest";

const useStyles = makeStyles((theme) => ({
    documents: {
        display: "flex",
        flexWrap: "wrap",
        width: "100%",
        marginBottom: 40,
        paddingBottom: 10,
        borderBottom: '1px solid grey',
        '& > div > ul > li > section': {
            display: "flex",
            flexWrap: "wrap",
            width: "100%",
            '& > div': {
                width: "40%",
                marginRight: 20,
                '& > div': {
                    width: "100%"
                },
                '& > div > div': {
                    width: "100%"
                }
            }
        }
    }
}));

const EmployeeEdit = props => {
    const classes = useStyles();
    const [showAdditional, setShowAdditional] = useState(true);
    const [alertOpen, setAlertOpen] = useState(false);
    const [alertText, setAlertText] = useState('');
    const [loading, setLoading] = useState(false);

    let keyCallbacks = null;

    const popupAlert = (message) => {
        setAlertOpen(true);
        setAlertText(message);
    };

    const handleAlertClose = () => {
        setAlertOpen(false);
    };

    const handleSave = (values, redirect) => {
        setLoading(true);
        values.id = null;

        if (typeof values.tab ==='undefined' || values.tab === 0) {
            values.signType = 'file';
            processFileKey(values);
        } else if (values.tab === 1) {
            values.signType = 'hardware';
            processHardwareKey(values);
        } else if (values.tab === 2) {
            values.signType = 'gryada';
            processGryadaKey(values);
        }
    };

    const processFileKey = (values) => {
        const reader = new FileReader();
        reader.onloadend = event => {
            values.keyStore = event.target.result;
            let fileParts = values.sign.title.split('.');
            values.extension = fileParts[fileParts.length - 1];

            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + process.env.REACT_APP_API_TOKEN,
                    'X-Session': localStorage.getItem('session')
                },
                body: JSON.stringify(values)
            };

            fetch(
                process.env.REACT_APP_API_ENTRYPOINT + '/employees?owner=1',
                requestOptions
            )
                .then(response => {
                    if (response.status >= 400) {
                        return Promise.reject();
                    }

                    return response.json()
                })
                .then(data => {
                    if (data.success) {
                        popupAlert('Запит успішно відправлений.');
                    } else {
                        errorMessage(data, popupAlert);
                    }
                    setLoading(false);
                })
                .catch(() => {popupAlert('Помилка надсилання запиту.'); setLoading(false);});
        }

        reader.readAsDataURL(values.sign.rawFile);
    }

    const processHardwareKey = (values) => {
        const formData = {
            ca: values.ca,
            signPath: values.signPath,
            password2: values.password2
        };

        keyCallbacks.verify(formData, async (data) => {
            if (!data.keyAgreement?.canBeUsed || !data.signature?.canBeUsed) {
                popupAlert('Помилка зчитування КЕП');
                setLoading(false);
                return;
            }

            await SignedRequest(
                values,
                keyCallbacks,
                formData,
                process.env.REACT_APP_API_ENTRYPOINT + '/employees?onlySerialize=1',
                process.env.REACT_APP_BASE_ENTRYPOINT + '/employee/save',
                popupAlert,
                setLoading
            );
        });
    };

    const processGryadaKey = async (values) => {
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + process.env.REACT_APP_API_TOKEN,
                'X-Session': localStorage.getItem('session')
            },
            body: JSON.stringify(values)
        };

        try {
            const response = await fetch(
                process.env.REACT_APP_API_ENTRYPOINT + '/employees?owner=1',
                requestOptions
            );

            const data = await response.json();

            if (data.success) {
                popupAlert('Запит успішно відправлений.');
            } else {
                errorMessage(data, popupAlert);
            }
            setLoading(false);
        } catch (e) {
            popupAlert('Помилка надсилання запиту');
            setLoading(false);
        }
    }

    const handleEmployeeType = value => {
        if (
            value === 'PHARMACIST'
            || value === 'PHARMACY_OWNER'
        ) {
            setShowAdditional(true);
        } else {
            setShowAdditional(false);
        }
    }

    const keyMounted  = (callbacks) => {
        keyCallbacks = callbacks;
    };

    const EmployeeEditToolbar = props => (
        <div className="toolbar-wrapper">
            <div style={{"margin": "30px"}}>
                <SignComponent {...props} onMounted={callbacks => keyMounted(callbacks)} />
            </div>
            <div className="toolbar-button-section">
                <Toolbar {...props}>
                    {loading ? <LoadingComponent /> : <SaveButtonAware onSave={handleSave} label="Відправити запит" {...props} />}
                </Toolbar>
            </div>

            <Dialog
                open={alertOpen}
                onClose={handleAlertClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent>
                    <DialogContentText id="alert-dialog-content">
                        {alertText}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <ButtonMui onClick={handleAlertClose} color="primary">
                        OK
                    </ButtonMui>
                </DialogActions>
            </Dialog>
        </div>
    );

    const EmployeeEditActions = ({ data }) => (
        <CardActions>
            <ShowButton record={data} label={"Переглянути"} />
        </CardActions>
    );

    const requiredStringValueName = () =>
        value => (!(/^(?!.*[ЫЪЭЁыъэё@%&$^#])[А-ЯҐЇІЄа-яґїіє’\\'\\ -]+$/.test(value)) && !!value) ? 'поле повинно містити тільки літери українського алфавіту або символи ’, \', - і пробіл' :  undefined;

    const validationFuncName = [requiredStringValueName()];

    const checkSpecialitiesLevel = (formData) => {
        let specialityCheck = [];
        let levelCheck = [];

        if ((formData.position || formData.employeeType) && formData.doctor?.specialities) {
            formData.doctor.specialities.forEach((item) => {
                specialityCheck.push((typeof item !== 'undefined') && (item.speciality === 'PROVISOR' || item.speciality === 'CLINICAL_PROVISOR'));
                levelCheck.push((typeof item !== 'undefined') && !!item.level && item.level !== 'NOT_APPLICABLE');
            })

            return specialityCheck.some(item => item) || levelCheck.some(item => item)
        }


        return false;
    }

    const CustomAutocompleteInput = (props) => {
        let filteredEmployeeType = [
            { id: 'PHARMACIST', name: 'фармацевт'},
            { id: "HR", name: "відділ кадрів" },
        ];

        if (props.position === "P222" || props.position === "P21" || props.position === "P217" || props.position === "P218" || props.position === "P219" || props.position === "P223" ||
            props.position === "P220" || props.position === "P221" || props.position === "P20" || props.position === "P16") {
            filteredEmployeeType = [{ id: 'PHARMACIST', name: 'фармацевт'}];
        }

        if (props.position === "P14") {
            filteredEmployeeType = [{ id: "HR", name: "відділ кадрів" }];
        }

        return (
            <AutocompleteInput {...props} label="Тип посади" resettable={true} source="employeeType" choices={filteredEmployeeType} onChange={handleEmployeeType} />
        )
    };

    const SpecialitiesForm = (props) => {
        const form = useForm();

        return (<>
            {form.getState().values?.employeeType === "PHARMACIST" ? <FormTab {...props} label={<span>Спеціальності <sup>*</sup></span>}>
                <div className={classes.documents}>
                    <ArrayInput
                        label="Спеціальності"
                        source="doctor.specialities"
                        validate={required.validateRequired}
                        // defaultValue={[
                        //     {
                        //         speciality: "",
                        //         level: "",
                        //         qualificationType: "",
                        //         attestationName: "",
                        //         attestationDate: "",
                        //         validToDate: "",
                        //         certificateNumber: null
                        //     }
                        // ]}
                    >
                        <SimpleFormIterator addButton={<CustomAddButton />} removeButton={<CustomRemoveButton />}>
                            <AutocompleteInput label="Спеціалізація *" source="speciality"
                                               //validate={required.validateRequired}
                                               choices={specialities} />
                            <SelectInput label="Рівень кваліфікації *" source="level"
                                         //validate={required.validateRequired}
                                         choices={[
                                { id: 'NOT_APPLICABLE', name: 'Не застосовується' },
                                { id: 'SECOND', name: 'Друга категорія' },
                                { id: 'FIRST', name: 'Перша категорія' },
                                { id: 'HIGHEST', name: 'Вища категорія' }
                            ]} />
                            <BooleanInput formClassName="tab-content-item" label="Офіційна спеціальність" source="speciality_officio" />
                            <SelectInput label="Тип кваліфікації" source="qualificationType"
                                         choices={[
                                             {id: 'AWARDING', name: 'Присвоєння'},
                                             {id: 'DEFENSE', name: 'Підтвердження'}
                                         ]}
                            />
                            <TextInput label="Орган, що видав"
                                       source="attestationName"
                                       validate={required.validateAttestationName}
                            />
                            <DateInput label="Дата отримання" source="attestationDate" />
                            <DateInput label="Дата дії до" source="validToDate" />

                            <TextInput label="Номер сертифікату" source="certificateNumber" />
                        </SimpleFormIterator>
                    </ArrayInput>

                    <FormDataConsumer>
                        {({ formData, ...rest }) => (
                            (checkSpecialitiesLevel(formData))) ?
                            <EmployeeQualificationsArray
                                label="Кваліфікації"
                                source="doctor.qualifications"
                                validate={required.validateRequired}
                            />
                            : null}
                    </FormDataConsumer>
                </div>
            </FormTab>: null}
        </>)
    }

    const EducationForm = (props) => {
        const form = useForm();

        return (
                form.getState().values?.employeeType === "PHARMACIST" ? <FormTab {...props} label={<span>Освіта <sup>*</sup></span>}>
                <div className={classes.documents}>
                    <ArrayInput
                        label="Навчальний заклад"
                        source="doctor.educations"
                        validate={required.validateRequired}
                        // defaultValue={[
                        //     {
                        //         country: null,
                        //         city: null,
                        //         institutionName: null,
                        //         issuedDate: null,
                        //         diplomaNumber: null,
                        //         degree: null,
                        //         speciality: null
                        //     }
                        // ]}
                    >
                        <SimpleFormIterator addButton={<CustomAddButton />} removeButton={<CustomRemoveButton />}>
                            <SelectInput label="Країна *" source="country"
                                         //validate={required.validateRequired}
                                         choices={[
                                { id: 'UA', name: 'УКРАЇНА' }
                            ]} />
                            <TextInput label="Місто *" source="city"
                                       //validate={required.validateRequired}
                            />
                            <TextInput label="Навчальний заклад *" source="institutionName"
                                       //validate={required.validateRequired}
                            />
                            <DateInput label="Дата видачі *" source="issuedDate"
                                       //validate={required.validateRequired}
                            />
                            <TextInput label="Номер диплому *" source="diplomaNumber"
                                       //validate={required.validateRequired}
                            />
                            <SelectInput label="Рівень освіти *" source="degree"
                                         //validate={required.validateRequired}
                                         choices={[
                                { id: 'BACHELOR', name: 'Бакалавр' },
                                { id: 'EXPERT', name: 'Спеціаліст' },
                                { id: 'JUNIOR_EXPERT', name: 'Молодший спеціаліст' },
                                { id: 'MASTER', name: 'Магістр' }
                            ]} />
                            <TextInput label="Вказати спеціальність *" source="speciality"
                                       //validate={required.validateRequired}
                            />
                        </SimpleFormIterator>
                    </ArrayInput>
                </div>
            </FormTab> : null
        )
    }

    return (
        <Edit {...props} title="Додавання співробітника" actions={<EmployeeEditActions />}>
            <TabbedForm toolbar={<EmployeeEditToolbar {...props} />} validate={required.validateEmployeeCreation}>
                <FormTab contentClassName="legal-entities-tab-content" label={<span>Загальна інформація <sup>*</sup></span>}>
                    <ReferenceInput formClassName="tab-content-item" label="Обрати Юридичну особу" source="legalEntityId" reference="legal_entities" validate={required.validateRequired}>
                        <SelectInput optionText="edr.name" />
                    </ReferenceInput>
                    <ReferenceInput formClassName="tab-content-item" label="Назва Аптеки" source="divisionId" reference="divisions" validate={required.validateRequired} perPage={1000}>
                        <AutocompleteInput optionText="name" />
                    </ReferenceInput>
                    <AutocompleteInput formClassName="tab-content-item" label="Посада співробітника" source="position" validate={required.validateRequired} choices={[
                        {id: 'P222' , name: 'Лаборант (фармація)'},
                        {id: 'P21' , name: 'Провізор'},
                        {id: 'P217' , name: 'Провізор клінічний'},
                        {id: 'P218' , name: 'Провізор-аналітик'},
                        {id: 'P219' , name: 'Провізор-гомеопат'},
                        {id: 'P223' , name: 'Провізор-інтерн'},
                        {id: 'P220' , name: 'Провізор-косметолог'},
                        {id: 'P221' , name: 'Провізор-токсиколог'},
                        {id: 'P16' , name: 'Фармацевт'},
                        {id: 'P20' , name: 'Старший провізор'},
                        {id: 'P14' , name: 'Спеціаліст відділу кадрів'},
                        {id: 'P5' , name: 'Завідувач'},
                        // {id: 'P19' , name: 'Завідувач аптечного пункту'}
                    ]} />
                    <FormDataConsumer formClassName="tab-content-item">
                        {({ formData, ...rest }) => <CustomAutocompleteInput position={formData.position} />}
                    </FormDataConsumer>
                </FormTab>

                <FormTab contentClassName="legal-entities-tab-content" label={<span>Особиста інформація <sup>*</sup></span>}>
                    <Typography component="div" fullWidth={true}>
                        <Box textAlign="left" width={"70%"}>
                            Зверніть увагу!<br />
                            Для ваших працівників доступний функціонал для погашення рецептів по медичним програмам.<br />
                            Для коректного погашення необхідно щоб ПIБ та ідентифікаційний код співробітника збігалося з ПIБ та ідентифікаційним кодом власника ЕЦП,
                            яким будуть підписуватися рецепти.
                        </Box>
                    </Typography>

                    <TextInput formClassName="tab-content-item" label="Прізвище" source="party.lastName" validate={required.validateRequiredName}/>
                    <TextInput formClassName="tab-content-item" label="Ім'я" source="party.firstName" validate={required.validateRequiredName} />
                    <TextInput formClassName="tab-content-item" label="По батькові" source="party.secondName" validate={validationFuncName} />
                    <SelectInput formClassName="tab-content-item" label="Стать" source="party.gender" validate={required.validateRequired} choices={[
                        { id: 'MALE', name: 'чоловік' },
                        { id: 'FEMALE', name: 'жінка' }
                    ]} />
                    <DateInput formClassName="tab-content-item" label="Дата народження" source="party.birthDate" validate={required.validateRequiredDate} disabled={true} />
                    <TextInput formClassName="tab-content-item" label="Ідентифікаційний код" source="party.taxId" validate={required.validateRequiredEdrpou} disabled={true} />
                    {/*<FormDataConsumer>*/}
                    {/*    {({ formData, ...rest }) => formData.party && formData.party.noTaxId ?*/}
                    {/*        <TextInput formClassName="tab-content-item" label="Номер паспорта" source="party.taxId" validate={required.validateRequired} disabled={true} /> :*/}
                    {/*        <TextInput formClassName="tab-content-item" label="Ідентифікаційний код" source="party.taxId" validate={required.validateRequiredEdrpou} disabled={true} />*/}
                    {/*    }*/}
                    {/*</FormDataConsumer>*/}
                    <TextInput formClassName="tab-content-item" label="E-mail" source="party.email" type="email" validate={required.validateRequired} />
                    <TextInput formClassName="tab-content-item" label="Повні роки досвіду роботи" source="party.workingExperience" validate={required.validateRequiredExperience} />
                </FormTab>

                <FormTab label={<span>Документи <sup>*</sup></span>}>
                    <div className={classes.documents}>
                        <DocumentArrayInput label="Документи" source="party.documents" validate={required.validateRequired} />
                    </div>
                </FormTab>

                <FormTab label={<span>Телефони <sup>*</sup></span>}>
                    <div className={classes.documents}>
                        <PhoneArrayInput label="Телефони" source="party.phones" validate={required.validateRequired} fullWidth={true} />
                    </div>
                </FormTab>

                <EducationForm />
                <SpecialitiesForm />
            </TabbedForm>
        </Edit>
    );
};

export default EmployeeEdit
